export default __webpack_public_path__ + "static/media/dipswitch@2x.80748f8b.png";